import { useMutation } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { selectAuthToken } from 'selectors';
import {
  getTeamsForExportApi,
  GetTeamsForExportResponse,
  GetTeamsForExportErrorResponse,
} from 'TeamModule/services/GetTeamsForExportApi';
import { AxiosResponse } from 'axios';
import { SearchTeamsByFieldsPayload } from 'TeamModule/api/searchTeamsByFieldsApi';
import { useContextHeaders } from 'hooks/useContextHeaders';

export const useTeamsForExportMutation = ({
  onSuccess,
}: {
  onSuccess?: (response: AxiosResponse<GetTeamsForExportResponse>) => void;
} = {}) => {
  const token = useSelector(selectAuthToken);
  const { buildConfig } = useContextHeaders();

  const mutation = useMutation<
    AxiosResponse<GetTeamsForExportResponse>,
    AxiosResponse<GetTeamsForExportErrorResponse>,
    SearchTeamsByFieldsPayload
  >({
    mutationFn: async (params) => {
      if (!token) throw new Error('No auth token available');
      // buildConfig() automatically includes URL context headers (tenant/realmId)
      return getTeamsForExportApi({ params, token, config: buildConfig() }) as Promise<
        AxiosResponse<GetTeamsForExportResponse>
      >;
    },
    onSuccess,
  });

  return {
    exportTeams: mutation.mutate,
    isExportingTeams: mutation.isPending,
  };
};
